<ng-container *transloco="let t; prefix: 'home.services'">
    <div class="px-4 pt-10 pb-16 backdrop-blur-[10px] lg:px-[72px] lg:pt-[72px] lg:pb-8 flex-col justify-start items-start gap-8 flex lg:gap-10">
        <div class="self-stretch flex-col justify-start items-start gap-4 flex">
            <div class="self-stretch flex-col justify-start items-start gap-4 flex">
                <div class="self-stretch text-black text-[40px] font-normal lg:opacity-90 lg_text-center lg:text-black lg:text-[64px]">
                    {{t('ourServices.title')}}
                </div>
                <div class="self-stretch opacity-90 text-[#50575f] text-base font-normal lg:max-w-[800px] lg:text-xl ">
                    {{t('ourServices.description')}}
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-y-4 lg:gap-y-10 lg:pt-8 w-full">
            <div class="w-full lg:w-[489px] ">
                <div
                  class="p-1 border-full border border-gray-500 flex flex-row rounded-full"
                >
                @for (category of clientCategories; track $index) {
                    <button
                      class="tab-pill flex-1 justify-center"
                      type="button"
                      [ngClass]="{ active: selectedCategory === category.id }"
                      (click)="toggleSwitch(category.id)"
                    >
                    {{t(category.label)}}
                    </button>
                }
                </div>
              </div>

            <div class="grid lg:grid-cols-2 gap-10">
                @if (selectedCategory == 'buyers') {
                    <div
                        class="bg-white flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1">
                        <div class="flex flex-col gap-4 mb-5">
                            <h3 class="rfs:text-3xl text-black"> {{ t("ourServices.buyers.dreamProperty.title") }} </h3>
                            <p class="text-gray-950"> {{ t("ourServices.buyers.dreamProperty.text") }} </p>
                        </div>
                        <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
                            <div class="flex items-end">
                                <button class="btn-primary" localizedRouterLink="/properties">{{ t("more") }}</button>
                            </div>
                            <div class="w-full flex justify-end lg:w-auto lg:block">
                                <img
                                    class="lg:h-[100px] xl:h-auto"
                                    src="./assets/services/find_your_dream_property.png"
                                    alt="" />
                            </div>
                        </div>
                    </div>

                    <div
                        class="bg-white flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1">
                        <div class="flex flex-col gap-4 mb-5">
                            <h3 class="rfs:text-3xl text-black"> {{ t("ourServices.buyers.financing.title") }} </h3>
                            <p class="text-gray-950"> {{ t("ourServices.buyers.financing.text") }} </p>
                        </div>
                        <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
                            <div class="flex items-end">
                                <button class="btn-primary" localizedRouterLink="/financing">{{ t("more") }}</button>
                            </div>
                            <div class="w-full flex justify-end lg:w-auto lg:block">
                                <img
                                    class="lg:h-[100px] xl:h-auto"
                                    src="./assets/services/financing.png"
                                    alt="" />
                            </div>
                        </div>
                    </div>
                } @else {
                    <div
                        class="bg-white flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1">
                        <div class="flex flex-col gap-4 mb-5">
                            <h3 class="rfs:text-3xl text-black"> {{ t("ourServices.sellers.dreamProperty.title") }} </h3>
                            <p class="text-gray-950"> {{ t("ourServices.sellers.dreamProperty.text") }} </p>
                        </div>
                        <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
                            <div class="flex items-end">
                                <button class="btn-primary" localizedRouterLink="/sell-property-get-started">{{ t("more") }}</button>
                            </div>
                            <div class="w-full flex justify-end lg:w-auto lg:block">
                                <img
                                    class="lg:h-[100px] xl:h-auto"
                                    src="./assets/services/sell_your_property.png"
                                    alt="" />
                            </div>
                        </div>
                    </div>

                    <div
                        class="bg-white flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1">
                        <div class="flex flex-col gap-4 mb-5">
                            <h3 class="rfs:text-3xl text-black"> {{ t("ourServices.sellers.financing.title") }} </h3>
                            <p class="text-gray-950"> {{ t("ourServices.sellers.financing.text") }} </p>
                        </div>
                        <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
                            <div class="flex items-end">
                                <button class="btn-primary" localizedRouterLink="/services/preapproval">{{ t("more") }}</button>
                            </div>
                            <div class="w-full flex justify-end lg:w-auto lg:block">
                                <img
                                    class="lg:h-[100px] xl:h-auto"
                                    src="./assets/services/certify_your_property.png"
                                    alt="" />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>

        <div class="flex flex-col gap-y-4 lg:gap-y-10 lg:pt-8 w-full">
            <div class="self-stretch text-black text-[32px] font-normal">
                 {{selectedCategory == 'buyers'? t('otherServices.buy'):t('otherServices.sell')}}
            </div>

            <section class="flex flex-col gap-6">
                <div class="h-auto flex flex-col justify-start items-start gap-8">
                    <div class="w-full overflow-hidden">
                        <div 
                            class="xl:grid xl:grid-cols-[repeat(auto-fit,287px)] flex xl:overflow-x-visible overflow-x-auto w-full flex-row gap-6"

                            > 
                            
                            @for (service of selectedCategory === 'buyers' ? buyersServiceData : sellersServiceData; track $index) {
                                <app-service-card
                                    class="xl:flex-1 xl:max-w-[287px]"
                                    [comingSoon]="service.comingSoon"
                                    [serviceType]="service.type"
                                    [title]="t(service.title)"
                                    [subtitle]="t(service.description)"
                                    [ctaTitle]="t(service.ctaLabel)"
                                    [imagePath]="service.img"
                                    (navigate)="reload($event)">
                                </app-service-card>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>

      <div class="flex flex-col gap-y-4 lg:gap-y-10 lg:pt-8 w-full">
                  <div class="self-stretch text-black text-[32px] font-normal">
                      {{t('otherServices.otherServices')}}
                  </div>

                  <section class="flex flex-col gap-6">
                      <div class="h-auto flex flex-col justify-start items-start gap-8">
                          <div class="w-full overflow-hidden">
                              <div class="xl:grid xl:grid-cols-[repeat(auto-fit,287px)] flex xl:overflow-x-visible overflow-x-auto w-full flex-row gap-6">
                                  @for (service of selectedCategory === 'buyers' ? buyersOtherServiceData : sellersOtherServiceData; track $index) {
                                      <app-service-card
                                          class="xl:flex-1 xl:max-w-[287px]"
                                          [comingSoon]="service.comingSoon"
                                          [serviceType]="service.type"
                                          [title]="t(service.title)"
                                          [subtitle]="service.description ? t(service.description) : ''"
                                          [ctaTitle]="t(service.ctaLabel)"
                                          [imagePath]="service.img"
                                          (navigate)="reload($event)">
                                      </app-service-card>
                                  }
                              </div>
                          </div>
                      </div>
                  </section>
              </div>
    </div>
</ng-container>


